module.exports = __webpack_public_path__ + "img/ethw.06b22260.png";